import { P, FF } from "../../styles/tokens";

export default function Pill({ label, token }) {
  const t = token || P.ingresos;
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "3px 10px",
        borderRadius: 99,
        background: t.pastel,
        color: t.text,
        fontSize: 11,
        fontWeight: 700,
        fontFamily: FF,
        border: `1.5px solid ${t.tint}`,
      }}
    >
      {label}
    </span>
  );
}
